const EMAIL_PATTERN = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi
const EMAIL_REPLACEMENT = "email-redacted"

function sanitizeText(value: string) {
  return value.replace(EMAIL_PATTERN, EMAIL_REPLACEMENT)
}

function sanitizePathname(pathname: string) {
  return pathname
    .split("/")
    .map((segment) => {
      if (!segment) {
        return segment
      }

      let decodedSegment = segment
      try {
        decodedSegment = decodeURIComponent(segment)
      } catch {
        decodedSegment = segment
      }

      const sanitizedSegment = sanitizeText(decodedSegment)
      return sanitizedSegment === decodedSegment ? segment : encodeURIComponent(sanitizedSegment)
    })
    .join("/")
}

export function sanitizeAnalyticsUrl(url: string, baseUrl = "https://www.udobaer.invalid") {
  try {
    const parsedUrl = new URL(url, baseUrl)
    parsedUrl.pathname = sanitizePathname(parsedUrl.pathname)

    const sanitizedSearchParams = new URLSearchParams()
    parsedUrl.searchParams.forEach((value, key) => {
      sanitizedSearchParams.append(key, sanitizeText(value))
    })
    parsedUrl.search = sanitizedSearchParams.toString()

    if (parsedUrl.hash) {
      parsedUrl.hash = sanitizeText(decodeURIComponent(parsedUrl.hash.replace(/^#/, "")))
    }

    return parsedUrl.href
  } catch {
    return sanitizeText(url)
  }
}

export function sanitizeAnalyticsPath(path: string) {
  const sanitizedUrl = sanitizeAnalyticsUrl(path)
  const parsedUrl = new URL(sanitizedUrl)
  return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`
}
